import type { LeadVisit } from "@school-sales-ai/shared";
import {
  STATUS_BADGE,
  STATUS_LABEL,
  formatVisitDateTime,
} from "@/components/visits/visit-status";

/** Compact visit summary, reused by the test-agent debug panel and (later) LeadDetail. */
export function VisitCard({ visit }: { visit: LeadVisit }): React.JSX.Element {
  return (
    <div className="flex flex-col gap-1.5 rounded-lg border border-ink-100 bg-white px-3.5 py-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[13px] font-semibold text-ink-900">📅 Visita agendada</span>
        <span
          className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${STATUS_BADGE[visit.status]}`}
        >
          {STATUS_LABEL[visit.status]}
        </span>
      </div>
      <p className="text-[13px] font-medium text-ink-800 first-letter:uppercase">
        {formatVisitDateTime(visit.startsAt)}
      </p>
      <p className="text-[12px] text-ink-500">
        {visit.durationMin} min
        {visit.advisorName ? ` · Recibe: ${visit.advisorName}` : ""}
      </p>
      {visit.rescheduleCount > 0 && (
        <p className="text-[12px] text-ink-400">
          Reprogramada {visit.rescheduleCount} {visit.rescheduleCount === 1 ? "vez" : "veces"}
        </p>
      )}
    </div>
  );
}
